export interface ForgotPasswordResponse {
  error: boolean;
  hasEmail: boolean;
  hasPassword: boolean;
  authenticationMethod: string;
}
